import Vue from 'vue'
import 'bootstrap'
import Axios from 'axios'
import App from './Main.vue'
import store from './stores'
import router from './router'
import pipe from './pipe'
import components from './components'
import VueSweetalert2 from 'vue-sweetalert2'
import vuetify from '@/assets/plugins/vuetify'
import b64toBlob from '@/assets/plugins/b64toBlob'
import * as VueGoogleMaps from 'vue2-google-maps'
import soundSuccess from '@/assets/media/sound2.ogg'
import soundError from '@/assets/media/sound4.ogg'
import JQuery from 'jquery'

import "@/assets/css/admin.css"
import "@/assets/css/vuetify.css"
import 'sweetalert2/dist/sweetalert2.min.css'
import 'popper.js/dist/popper.min.js'
import VueTheMask from 'vue-the-mask'

import moment from 'moment'
import html2pdf from 'html2pdf.js'
import 'es6-promise/auto'

Vue.config.productionTip = false
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: true
});

Vue.use(VueSweetalert2)
Vue.use(VueGoogleMaps, { load: { key: process.env.MAP } })
Vue.use(VueTheMask)

window.soundSuccess = soundSuccess
window.soundError = soundError
window.axios = Axios
window.$ = JQuery
window.moment = moment
window.html2pdf = html2pdf
window.b64toBlob = b64toBlob

const access_token = localStorage.getItem('access_token')
axios.defaults.baseURL = process.env.API
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
if (access_token){
  axios.defaults.headers.common['Authorization'] = access_token
}

axios.interceptors.response.use(function (error) {
  return error;
}, function (error) {
  if(error.code !== 'ECONNABORTED' && error.code !== 'ERR_CANCELED'){
    if(error.response.status !== 422 && error.response.status !== 404 && error.response.status !== 400){
      error.message = 'Ocurrió un error al procesar su solicitud'
      error.response.message = 'Ocurrió un error al procesar su solicitud'
      if(!error.response.data.message){
        error.response.data.message = 'Ocurrió un error al procesar su solicitud'
      }
    }
  }
  return Promise.reject(error)
})

const app = new Vue({
  components,
  pipe,
  vuetify,
  router,
  store,
  render: h => h(App),
  watch: {
    $route (to, from){
      store.dispatch('MAXPAGE', false)
      localStorage.removeItem('option_billing')
      localStorage.removeItem('tab_package_update')
      localStorage.removeItem('tab_calculator_update')
      localStorage.removeItem('tab_user_update')
    }
  }
}).$mount('#app')

// app.use(cors())
